import React from 'react';
/* eslint-disable */
export const IconBurger = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 21H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 11H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
);
